/**
 * Variant radios for D2C complementary product blocks: sync hidden input, price, ATC state.
 * Card slideshow: hide arrows when content fits (theme keeps next enabled if IntersectionObserver only counts one slide).
 */
(function () {
  const docEl = document.documentElement;
  if (docEl.dataset.d2cComplementaryBound === 'true') return;
  docEl.dataset.d2cComplementaryBound = 'true';

  const SCROLL_EPS_PX = 4;

  /**
   * @param {Element} slideshow
   */
  function syncCompSlideshowNoScroll(slideshow) {
    if (!(slideshow instanceof HTMLElement)) return;
    const scroller = slideshow.querySelector('slideshow-slides');
    if (!(scroller instanceof HTMLElement)) return;
    const noScroll = scroller.scrollWidth <= scroller.clientWidth + SCROLL_EPS_PX;
    slideshow.toggleAttribute('data-d2c-comp-no-scroll', noScroll);
  }

  /**
   * @param {Element} slideshow
   */
  function bindCompCardSlideshow(slideshow) {
    if (!(slideshow instanceof HTMLElement) || !slideshow.classList.contains('d2c-comp__slideshow--cards')) return;
    const scroller = slideshow.querySelector('slideshow-slides');
    if (!(scroller instanceof HTMLElement)) return;

    const run = () => syncCompSlideshowNoScroll(slideshow);
    const ro = new ResizeObserver(run);
    ro.observe(scroller);
    scroller.addEventListener('scroll', run, { passive: true });
    queueMicrotask(run);
    requestAnimationFrame(run);
  }

  document.querySelectorAll('.d2c-comp__slideshow--cards').forEach(bindCompCardSlideshow);

  /**
   * @param {HTMLInputElement} input
   */
  const priceFmtFromInput = (input) => input.dataset?.priceFmt || '';

  /**
   * @param {HTMLInputElement} input
   */
  const compareFmtFromInput = (input) => input.dataset?.compareFmt || '';

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.classList.contains('d2c-comp__variant-input')) return;

    const form = target.closest('form');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (idInput instanceof HTMLInputElement) {
      idInput.value = target.value;
    }

    const comp = target.closest('.d2c-comp');
    const priceRow = comp?.querySelector('[data-d2c-comp-price]');
    if (priceRow) {
      const cur = priceRow.querySelector('[data-role="current-price"]');
      const cmp = priceRow.querySelector('[data-role="compare"]');
      if (cur) {
        cur.textContent = priceFmtFromInput(target);
      }
      if (cmp) {
        const cf = compareFmtFromInput(target);
        cmp.textContent = cf;
        cmp.toggleAttribute('hidden', !cf);
      }
    }

    const btn = form.querySelector('button[type="submit"][name="add"]');
    if (btn instanceof HTMLButtonElement) {
      const avail = target.dataset.available === 'true';
      btn.disabled = !avail;

      const formRoot = form.closest('product-form-component');
      const atcWrap = form.querySelector('add-to-cart-component');
      if (atcWrap instanceof HTMLElement) {
        const mediaUrl = target.dataset.variantMedia;
        if (mediaUrl) {
          atcWrap.dataset.productVariantMedia = mediaUrl;
        }
      }
      if (!avail && formRoot) {
        const err = formRoot.querySelector('.product-form-text__error');
        err?.classList.add('hidden');
      }

      const addTxt = formRoot instanceof HTMLElement ? formRoot.dataset.atcAdd || '' : '';
      const soldTxt = formRoot instanceof HTMLElement ? formRoot.dataset.atcSold || '' : '';
      const span = btn.querySelector('.add-to-cart-text__content span span');
      if (span && addTxt && soldTxt) {
        span.textContent = avail ? addTxt : soldTxt;
      }
    }
  });
})();
